module.exports = __webpack_public_path__ + "assets/img/c8a81576662b01d6f3a73ecd056a600a.png";